import "./language.css";

const Skills = () => {
  return (
    <section id="language">
      <span className="skillTitle">Languages Known</span>
      <div className="skillsList">
        <div className="skillItem">
          <span className="lang">English</span>
          <span className="level">Fluent</span>
        </div>
        <div className="skillItem">
          <span className="lang">Kannada</span>
          <span className="level">Fluent</span>
        </div>
        <div className="skillItem">
          <span className="lang">Hindi</span>
          <span className="level">Intermediate</span>
        </div>
      </div>
    </section>
  );
};

export default Skills;
